export default __webpack_public_path__ + "static/media/icon-list.71af4421.svg";